import React from 'react';
import { Switch } from 'react-router-dom';
import { PermissionRoute } from '../../components/AdminOnly';
import { PERMISSIONS } from '../../lib/authManager';

import MonthSummary from './MonthSummary';
import Transactions from '../Settings/Transactions';
import Exporter from '../Settings/Exporter';
import ParkingInventory from '../Settings/ParkingInventory';

/**
 * Transactions is the only report gated on its own permission — a hotel can be
 * given `transactions:read` without getting the rest of the Reports section.
 * `insights_revenue:read` only exposes the embedded list in Insights Overview.
 * The others keep the `reports:export` gate the parent /reports route used to
 * apply on its own.
 */
export default function ReportsPage({ match }) {
    return (
        <Switch>
            <PermissionRoute
                exact
                path={`${match.path}/monthly-summary`}
                component={MonthSummary}
                permissions={PERMISSIONS.REPORTS_EXPORT}
            />
            <PermissionRoute
                path={`${match.path}/transactions`}
                component={Transactions}
                permissions={PERMISSIONS.TRANSACTIONS_READ}
            />
            <PermissionRoute
                path={`${match.path}/data-export`}
                component={Exporter}
                permissions={PERMISSIONS.REPORTS_EXPORT}
            />
            <PermissionRoute
                exact
                path={`${match.path}/parking-inventory`}
                component={ParkingInventory}
                permissions={PERMISSIONS.REPORTS_EXPORT}
            />
        </Switch>
    );
}
